var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 6,
    viewBox: "0 0 2 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 6,
    rx: 1,
    fill: "url(#paint0_linear_143_50620)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_143_50620",
    x1: 2.00033,
    y1: 0.000983058,
    x2: -1.59967,
    y2: 1.20098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDDFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineGrey);
export default __webpack_public_path__ + "static/media/line-grey.2c4a9b63081d246ba7104ef5c3932cf5.svg";
export { ForwardRef as ReactComponent };